import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ShoppingRecurrenceEdition,
  ShoppingRecurrenceEditionRepository
} from '@infrab4a/connect';
import { retry } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopShoppingRecurrenceEditionService extends BaseConnectService<ShoppingRecurrenceEdition> {
  private get cloudFunctionsUrl(): string {
    return `https://southamerica-east1-${environment.connectFirebase.projectId}.cloudfunctions.net`;
  }

  constructor(
    @Inject('ShoppingRecurrenceEditionRepository')
    private editionRepository: ShoppingRecurrenceEditionRepository,
    private httpClient: HttpClient
  ) {
    super(editionRepository);
  }

  async getByRecurrenceId(recurrenceId: string) {
    return this.editionRepository.find({
      filters: { recurrenceId },
      orderBy: { scheduledDate: 'desc' }
    });
  }

  skipShoppingRecurrenceEdition(recurrenceEditionId: string) {
    return this.httpClient
      .post(`${this.cloudFunctionsUrl}/skipShoppingRecurrenceEdition`, {
        recurrenceEditionId
      })
      .pipe(retry(1));
  }
}
